module.exports = __webpack_public_path__ + "img/img15.9a6c8810.png";